import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-range-slider',
  templateUrl: './range-slider.component.html',
  styleUrls: ['./range-slider.component.scss']
})
export class RangeSliderComponent {

  @Input() value:any = 0;
  @Input() title:any = 'Title';
  @Input() max:any = 0;
  @Input() min:any = 1;
  @Input() step:any = 0.1;
  @Output() valueChange = new EventEmitter<number>();
  
  

  calculatePercentage() {
    const percentage = ((this.value - this.min) / (this.max)) * 100;  
    return percentage;  // Format to one decimal place
  }

  getBackground() {
    const percentage  = this.calculatePercentage();
    return `linear-gradient(to right, #00859f ${percentage}%, #d1d1d1 ${percentage}%)`;
  }
  
  updateValue(event: any) {
    this.value = event.target.value;
    this.valueChange.emit(this.value);
  }


}
